import React, {useEffect, useRef, useState} from "react";

import Modal from 'react-modal';
import 'pure-react-carousel/dist/react-carousel.es.css';

Modal.setAppElement('#root');

function Gallery({images, close}: {images: string[]|null, close: React.Dispatch<any>}): React.ReactElement {
    const slides = useRef<any>(null);

    if (images === null){
        return <></>;
    }

    const isGallery = images.length > 1;
    const imagesAmount = images.length;

    function Buttons(): React.ReactElement {
        return(
            <div className={'buttons'}>
                <button type={'button'} className={'prev'} onClick={() => {
                    const prev = (parseInt(slides.current?.style.marginLeft) + 100);

                    slides.current.style.marginLeft = prev > 0 ? '0%' : prev+'%'
                }} >
                    {isGallery ? <i className="fas fa-angle-left" /> : ''}
                </button>
                <button type={'button'} className={'next'} onClick={() => {
                    const next = (parseInt(slides.current?.style.marginLeft) - 100);

                    slides.current.style.marginLeft = (next <= ((imagesAmount-1) * -100) ? ((imagesAmount-1) * -100)+'%' : next+'%')
                }} >
                    {isGallery ? <i className="fas fa-angle-right" /> : ''}
                </button>
            </div>
        );
    }

    function Slides(): React.ReactElement {
        if (images === null){
            return <></>;
        }

        const wrapperWidth = 100 * images.length;
        const slideWidth = 100 / images.length;

        return (
            <div className={'wrapper'} >
                <div className={'slides'} ref={slides} style={{width: wrapperWidth+'%', marginLeft: '0%'}} >
                    {images?.map((image: string, index: number) => {
                        return (
                            <div className={'slide'} style={{width: slideWidth+'%'}} >
                                <img src={image} />
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

    function Thumbs(): React.ReactElement {
        const [active, setActive] = useState(0);

        console.log(slides.current?.style.marginLeft);

        useEffect(() => {


            setActive(parseInt(slides.current?.style.marginLeft) / -100);
        }, [slides.current?.style.marginLeft]);

        if (isGallery && images !== null){
            return(
                <div className={'thumbs'}>
                    {images.map((image: string, index: number) => {
                        return (
                            <div className={'thumb'+(active === index ? ' active' : '')} >
                                <img src={image} onClick={() => {
                                    slides.current.style.marginLeft = (index * -100)+'%';
                                }} />
                            </div>
                        );
                    })}
                </div>
            );
        }

        return <></>;
    }

    return(
        <Modal isOpen={true} onRequestClose={() => close(null)} shouldCloseOnOverlayClick={true} shouldCloseOnEsc={true} >
            <button type={'button'} className={'close-modal'} onClick={() => close(null)} ><i className={'fas fa-times'} /></button>

            <div className={'gallery'} >
                <Buttons />

                <Slides />

                <Thumbs />
            </div>
        </Modal>
    );
}



export {Gallery};